var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-heroblock" }, [
    this.background && this.background.IsVideo
      ? _c("div", { staticClass: "c-heroblock-video" }, [
          _c("div", {
            domProps: { innerHTML: _vm._s(this.background.Content) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "c-heroblock-overlay" }),
        ])
      : _c("div", { staticClass: "c-heroblock-media" }, [
          _c("picture", [
            _c("img", {
              staticClass: "c-heroblock-picture",
              attrs: {
                alt: "Background Image",
                loading: "lazy",
                src: this.background.Content,
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-heroblock-overlay" }),
        ]),
    _vm._v(" "),
    _c("div", { class: _vm.computedClassList, style: _vm.containsText }, [
      _c(
        "h2",
        { staticClass: "c-heroblock-text__title", style: _vm.setColor },
        [_vm._v(_vm._s(_vm.heading))]
      ),
      _vm._v(" "),
      _c("p", { style: _vm.setColor }, [_vm._v(_vm._s(_vm.preamble))]),
      _vm._v(" "),
      _vm.buttonLink
        ? _c(
            "a",
            {
              staticClass: "c-heroblock-text__button",
              class: _vm.additionalClasses,
              style: _vm.setColorButton,
              attrs: { href: _vm.buttonLink },
            },
            [_vm._v(_vm._s(_vm.buttonText))]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }